import Vue from 'vue'

const type = Vue.config.productionTip ? 'dev' : 'prod'

const configs = {
  prod: {
    API_IP: 'https://api.ncmhelper.com.br/meu-gestor/',
    SOCKET_IP: 'https://api.ncmhelper.com.br',
    JWT_PASSWORD: 'chewbacca_from_gestor'
  },
  dev: {
    API_IP: 'https://api.ncmhelper.com.br/meu-gestor/',
    SOCKET_IP: 'https://api.stg.planos.dev',
    JWT_PASSWORD: 'chewbacca_from_gestor'
  }
}

export default configs[type]
